// extracted by mini-css-extract-plugin
export var labelWrapper = "_br-0";